export const CANNON_WARNING_TICKS = 60;
export const CANNON_BALL_TICKS = 180;
export const CANNON_MUZZLE = 0.75;

type CannonParams = { param0: number; param1: number; param2: number; param3: number; armed: number; hp: number };

export function cannonPhase(hz: Pick<CannonParams, 'param0' | 'param2'> & { hp?: number }, tick: number): number {
  const period = Math.max(240, hz.param0 || 360);
  const elapsed = tick - Math.max(0, (hz.hp ?? 0) - 1);
  return ((elapsed + hz.param2) % period + period) % period;
}

/** One ball per emitter, with its flight derived from the replicated clock and active flag. */
export function cannonBall(hz: CannonParams, x: number, y: number, tick: number) {
  const age = cannonPhase(hz, tick) - CANNON_WARNING_TICKS;
  if (!hz.hp || !hz.armed || age < 0 || age >= CANNON_BALL_TICKS) return null;
  const vx = (hz.param3 < 0 ? -1 : 1) * hz.param1;
  return { x: x + (hz.param3 < 0 ? -1 : 1) * CANNON_MUZZLE + vx * age / 60, y, vx, vy: 0 };
}
